<div class="card m-3">
  <div class="card-body">

    <div class="grid-header">
      <h2 class="grid-title">
        <img src="./assets/manufacture.png" width="46px" alt="">
        Project Bids
      </h2>
      <a routerLink="/project-bids/add">
        <button mat-raised-button color="primary">
          <mat-icon>add</mat-icon> Add Bid
        </button>
      </a>
    </div>

    <div class="search-bar">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text" [(ngModel)]="searchTerm"
             placeholder="Search by company, contractor, type, status…"
             class="search-input" />
      <button *ngIf="searchTerm" mat-icon-button class="clear-btn" (click)="searchTerm = ''">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="table-wrap mat-elevation-z2">
      <table class="table table-striped table-sm bid-table">
        <thead>
          <tr>
            <th>Company</th>
            <th *ngIf="!isMobile">Contractor</th>
            <th>Bid Amount</th>
            <th *ngIf="!isMobile">Type</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bid of filteredProjectBids">
            <td class="primary-cell">{{ bid.companyName }}</td>
            <td *ngIf="!isMobile">{{ bid.contractor?.name }}</td>
            <td class="currency-cell">{{ bid.bidAmount | currency }}</td>
            <td *ngIf="!isMobile">{{ bid.projectType?.type }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(bid.status)">
                {{ bid.status }}
              </span>
            </td>
            <td>
              <div class="row-actions">
                <button mat-mini-fab color="primary" class="action-fab"
                        (click)="editProjectBid(bid)" matTooltip="Edit bid">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredProjectBids.length === 0">
            <td [attr.colspan]="isMobile ? 4 : 6" class="empty-state">
              <mat-icon>inbox</mat-icon>
              <span>No bids found</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="record-count" *ngIf="filteredProjectBids.length > 0">
      Showing {{ filteredProjectBids.length }} of {{ projectBids.length }}
      bid{{ projectBids.length !== 1 ? 's' : '' }}
    </div>

  </div>
</div>
